<div class="nosotros-container">
  
  <!-- Hero Section -->
  <section class="hero-section">
    <div class="hero-content">

      <div class="hero-image">
        <img src="../../assets/images/img/ilustraciones/lolo-cantando.webp" alt="Lolo - Mascota de All Tickets" class="lolitos-image">
      </div>

      <div class="hero-text">
        
        <h1 class="main-title">Conoce <span class="highlight">ALL TICKETS</span></h1>

        <p class="hero-subtitle">Los eventos dan vida, nosotros te vendemos los tickets</p>

      </div>
    </div>
    <div class="hero-decoration">
      <div class="floating-element element-1"></div>
      <div class="floating-element element-2"></div>
      <div class="floating-element element-3"></div>
    </div>
  </section>

  <!-- Quiénes Somos Section -->
  <section class="quienes-somos-section">
    <div class="quienes-somos-content">
      <div class="content-centered">
        <div class="lolo-image-container">
          <img src="../../assets/images/img/ilustraciones/lolitos.webp" alt="Lolitos - Representando quiénes somos" class="lolitos-hero-image">
        </div>
        <h2 class="section-title-special">¿Quiénes somos?</h2>
        <div class="text-content-centered">
          <p class="section-text-white">
            Somos All Tickets, una empresa colombiana especializada en ticketing. Nuestra pasión es la innovación y el desarrollo 
            constante para transformar la forma en que vives tus eventos.
          </p>
          <p class="section-text-white">
            Con nosotros puedes comprar tus entradas desde cualquier lugar, en cualquier momento, y recibirlas al instante. 
            Nos encargamos de que tu experiencia sea fácil, rápida y segura, para que tú solo te preocupes por una cosa: 
            <span class="highlight-text-orange">¡Vivirlo al máximo!</span>
          </p>
        </div>
      </div>


    </div>
           <div class="checkered-pattern"></div>

  </section>

  <!-- Misión Section -->
  <section class="mission-section">
    <div class="content-wrapper reverse">
      <div class="text-content">
        <h2 class="section-title">Misión</h2>
        <p class="section-text">
          En ALL TICKETS nos proyectamos como una tiquetera amigable, cercana y confiable para nuestros usuarios y clientes. 
          Nos caracterizamos por ofrecer un excelente servicio al cliente, enfocado en su comodidad y satisfacción. 
          Queremos construir confianza a través de la tecnología que implementamos y siempre estamos en constante desarrollo 
          e innovación, mejorando continuamente cada aspecto de lo que hacemos para brindar experiencias únicas y eficientes.
        </p>
      </div>
      <div class="image-content">
        <img src="../../assets/images/img/ilustraciones/trebol.webp" alt="Trébol - Símbolo de nuestra misión" class="section-image trebol-image">
      </div>
    </div>
  </section>

  <!-- Visión Section -->
  <section class="vision-section">
    <div class="content-wrapper reverse">
      <div class="image-content">
        <img src="../../assets/images/img/ilustraciones/ojo.webp" alt="Ojo - Símbolo de nuestra visión" class="section-image ojo-image">
      </div>
      <div class="text-content">
        <h2 class="section-title">Visión</h2>
        <p class="section-text">
          Mantenernos como una tiquetera tecnológica y ágil, que brinde propuestas innovadoras revolucionando el ticketing, 
          aprovechando nuestras herramientas tecnológicas y adecuándonos a los cambios del mercado. Continuar posicionándonos 
          en el mercado por nuestro enfoque en el servicio al cliente, constante desarrollo tecnológico y operativo y la 
          transparencia en nuestra gestión.
        </p>
      </div>
    </div>
  </section>

  <!-- Valores Section -->
  <section class="values-section">
    <div class="content-wrapper reverse">
      <div class="text-content">
        <h2 class="section-title">Valores</h2>
        <div class="values-grid">
          <div class="value-item">
            <span class="value-dot"></span>
            <span class="value-text">Innovación</span>
          </div>
          <div class="value-item">
            <span class="value-dot"></span>
            <span class="value-text">Confianza</span>
          </div>
          <div class="value-item">
            <span class="value-dot"></span>
            <span class="value-text">Accesibilidad</span>
          </div>
          <div class="value-item">
            <span class="value-dot"></span>
            <span class="value-text">Experiencia del usuario</span>
          </div>
          <div class="value-item">
            <span class="value-dot"></span>
            <span class="value-text">Eficiencia</span>
          </div>
        </div>
      </div>
      <div class="image-content">
        <img src="../../assets/images/img/ilustraciones/corazon.webp" alt="Corazón - Símbolo de nuestros valores" class="section-image corazon-image">
      </div>
    </div>
  </section>

  <!-- Evolución Section -->
  <section class="evolution-section">
    <div class="evolution-content">
      <h2 class="section-title center">Nuestra Evolución</h2>
      <div class="timeline">
        <div class="timeline-item">
          <div class="timeline-year">2018</div>
          <div class="timeline-logo">
            <img src="../../assets/images/img/Antiguo Logo All Tickets.png" alt="Logo antiguo All Tickets 2018" class="logo-old">
          </div>
          <div class="timeline-description">Nuestros inicios</div>
        </div>
        
        <div class="timeline-connector">
          <div class="connector-line"></div>
          <div class="connector-arrow"></div>
        </div>
        
        <div class="timeline-item">
          <div class="timeline-year">2025</div>
          <div class="timeline-logo">
            <img src="../../assets/images/img/Logo naranja.png" alt="Logo actual All Tickets 2025" class="logo-new">
          </div>
          <div class="timeline-description">Nuestra identidad actual</div>
        </div>
      </div>
    </div>
  </section>

  <!-- Decorative Lolo Section -->
  <section class="lolo-section">
    <div class="lolo-content">
      
      <div class="animated-text">
        <h3 class="scroll-text">¡Vívelo al máximo!</h3>
      </div>
<div class="lolo-character">
        <img src="../../assets/images/img/ilustraciones/lolo-chill.webp" alt="Lolo relajado" class="lolo-chill">
      </div>
    
    </div>
  </section>

</div>